import clientfeathers from './feathers';

export const serverFindData = (service, query) => () => {
    
    return clientfeathers.service(service).find({ query: query }).then(
        data => {
            return data;
        }
    ).catch( 
        error => {
            return {
                total : 0,
                data : []
            };
        }
    )
}

export const serverGetAllData = (service) => () => {
    
    return clientfeathers.service(service).find().then(
        data => {
            return data;
        }
    ).catch( 
        error => {
            return {
                total : 0,
                data : []
            };
        }
    )
}

export const serverUpdateData = (service, id, data) => () => {

    return clientfeathers.service(service).update(id, data).then(
        data => {
            return {
                status : true,
                mensaje : "Se ha actualizado correctamente."
            };
        }
    ).catch( 
        error => {
            return {
                status : false,
                mensaje : "Ha ocurrido un error. Por favor vuelva a intentar."
            };
        }
    )
}

export const serverCreateData = (service, data) => () => {

    return clientfeathers.service(service).create(data).then(
        data => {
            
            return {
                status : true,
                mensaje : "Se ha creado correctamente."
            };
        }
    ).catch( 
        error => {
            
            return {
                status : false,
                mensaje : "Ha ocurrido un error. Por favor vuelva a intentar."
            };
        }
    )
}

export const serverDelete = (service, id) => () => {

    return clientfeathers.service(service).remove(id).then(
        data => {
            return {
                status : true,
                mensaje : "Se ha eliminado correctamente."
            };
        }
    ).catch( 
        error => {
            return {
                status : false,
                mensaje : "Ha ocurrido un error. Por favor vuelva a intentar."
            };
        }
    )
}

export const serverFindDataDefault = (service, query) => () => {
    
    return clientfeathers.service(service).find({ query: query }).then(
        data => {
            return data;
        }
    ).catch( 
        error => {
            return Promise.reject(error);
        }
    )
}